import React from "react";

const BALL_IMG = `${import.meta.env.BASE_URL}assets/img/balls/ball-blank.png`;

/** Reference result body for Lucky 15: the ball with the round's rdesc ("2 Run", "Wicket", ...). */
export default function Lucky15ResultBody({ t1 }) {
  return (
    <div className="d-flex justify-content-center">
      <div className="cricket20ballpopup cricket20ballresult">
        <img src={BALL_IMG} alt="" /> <span>{t1?.rdesc}</span>
      </div>
    </div>
  );
}
